export default __webpack_public_path__ + "static/media/hero-bcg3.400f8f62.jpg";